/** How much of a sample value the suggestion menu shows beside its path. */
const SAMPLE_PREVIEW_CHARS = 40;

/** One line of a sample value for the suggestion menu. */
export function previewSample(value: unknown): string {
  let text: string;
  if (value === undefined) {
    return "";
  } else if (value === null) {
    text = "null";
  } else if (typeof value === "string") {
    text = value;
  } else if (typeof value === "object" && !Array.isArray(value)) {
    text = "{…}";
  } else {
    text = JSON.stringify(value);
  }
  return text.length > SAMPLE_PREVIEW_CHARS
    ? `${text.slice(0, SAMPLE_PREVIEW_CHARS - 1)}…`
    : text;
}
